export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
  vapidKey: string;
}

export interface RuntimeConfig {
  APP_URL: string;
  API_URL: string;
  JITSI_VOICE_SERVER_URL: string;
  JITSI_VIDEO_SERVER_URL: string;
  GOOGLE_CLIENT_ID?: string;
  FIREBASE?: FirebaseConfig;
  // Consola de supervisión: si true, usa datos simulados en vez de los
  // endpoints agregadores de tmc-sac (desarrollo local sin backend).
  SUPERVISOR_USE_MOCK?: boolean;
  // Feature expedientes (F5): cola y atención agrupadas por expediente.
  // Apagado (o ausente) = comportamiento clásico por alerta. Solo encender
  // en entornos con el backend de expedientes desplegado (sac F2 + gdp F3)
  // y la ventana de migración F4 ejecutada.
}

declare global {
  interface Window {
    __APP_CONFIG__?: Partial<RuntimeConfig>;
  }
}

const config = window.__APP_CONFIG__;

if (!config) {
  throw new Error('window.__APP_CONFIG__ is not defined');
}

const requiredKeys: (keyof RuntimeConfig)[] = [
  'APP_URL',
  'API_URL',
  'JITSI_VOICE_SERVER_URL',
  'JITSI_VIDEO_SERVER_URL',
];

requiredKeys.forEach((key) => {
  if (!config[key]) {
    throw new Error(`Missing runtime config key: ${key}`);
  }
});

export default config as RuntimeConfig;